
import { Component, Prop, Vue } from 'vue-property-decorator';
import { TagInterface, TagRepositoryInterface } from '@/services/QC-V2/tag/interfaces';

@Component({
  inject: [
    'tagRepositoryV2',
  ],
})
export default class DeleteTagDialog extends Vue {
  @Prop() public tag!: TagInterface;
  private visible: boolean = true;
  private tagRepositoryV2!: TagRepositoryInterface;

  get message(): string {
    return `Are you sure you want to delete ${this.tag.label}?`;
  }

  private async deleteTag(): Promise<void> {
    try {
      await this.tagRepositoryV2.deleteTag(this.tag.id);
      this.$successDialog.show('Tag deleted successfully');
      this.destroyComponent();
    } catch (e) {
      this.$errorDialog.show(e.response?.data?.message);
    }
  }

  private destroyComponent(): void {
    this.$emit('close');
  }
}
